import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import styled from "@emotion/styled";
import { setColor } from "../../../assets/styles/styles";
import { default as Button } from "../../../components/common/button/Button";
import Typography from "../../../components/common/text/Typography";
import { GetRoomTypePrefabs, UpdateRoomTypePrefab } from "../../../api/RoomsController";
import { CACHE_QUERY_OPTIONS } from "../../../constants";

const UpdateRoomPrefabModal = ({
    roomType,
    setOpenRoomPrefabModal,
    setIsSuccess,
    setSuccessMessage,
    setErrorMessage,
    setIsError,
    refetch,
}) => {
    const [roomTypeToSend, setRoomTypeToSend] = useState("");
    const [prefabRef, setPrefabRef] = useState("");
    const [prefabId, setPrefabId] = useState("");

    const { data, error, isLoading } = useQuery(["roomPrefabs"], () => GetRoomTypePrefabs(), {
        ...CACHE_QUERY_OPTIONS(),
    });

    useEffect(() => {
        if (data) {
            if (data.length > 0) {
                data.forEach((element) => {
                    if (element.roomType === roomType) {
                        setPrefabRef(element.prefabRef);
                        setRoomTypeToSend(element.roomType);
                        setPrefabId(element.id);
                    }
                });
            }
        }
    }, [data]);

    const UpdatePrefab = async () => {
        const data = {
            prefabRef,
        };
        const resp = await UpdateRoomTypePrefab(prefabId, data);
        if (resp.status === 200) {
            setIsSuccess(true);
            setIsError(false);
            setSuccessMessage("Prefab updated successfully");
        }
        if (resp.status !== 200) {
            setIsSuccess(false);
            setIsError(true);
            setErrorMessage("Prefab update failed");
        }
        setOpenRoomPrefabModal(false);
        refetch();
    };

    return (
        <>
            <Card>
                <Typography variant="PinkHeading">Update Room Type Prefab</Typography>
                <Columm>
                    <Label>Id</Label>
                    <InputBox type="text" value={prefabId} disabled />
                </Columm>
                <Columm>
                    <Label>Room Type</Label>
                    <InputBox
                        type="text"
                        placeholder="Enter Room Type"
                        value={roomTypeToSend}
                        onChange={(e) => setRoomTypeToSend(e.target.value)}
                        disabled
                    />
                </Columm>
                <Columm>
                    <Label>Prefab</Label>
                    <InputBox
                        type="text"
                        placeholder="Enter Prefab Ref (UUID from Unity)"
                        value={prefabRef}
                        onChange={(e) => setPrefabRef(e.target.value)}
                    />
                </Columm>
                <YellowText>Note: Changes will be applied to all rooms of this type</YellowText>
                <Button variant={"PinkButton"} label={"Update"} margin={"1rem 0rem 0rem 0rem"} onClick={UpdatePrefab} />
            </Card>
        </>
    );
};

export default UpdateRoomPrefabModal;

const Card = styled.div`
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const InputBox = styled.input`
    padding: 10px;
    border: ${(props) => (props.errorMessage ? `1px solid ${setColor.errorColor}` : `1px solid ${setColor.grey1}`)};
    border-radius: 5px;
    color: ${setColor.inputText};
    width: ${(props) => (props.width ? props.width : "100%")};
    background-color: transparent;
    margin-bottom: ${(props) => (props.errorMessage ? "0.5rem" : "0rem")};
    &:disabled {
        background-color: ${setColor.grey1};
    }
`;
const Label = styled.div`
    font-size: 16px;
    color: ${setColor.inputText};
    margin-left: 5px;
`;

const Columm = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0.5rem 0rem;
`;

const YellowText = styled.div`
    font-size: 14px;
    color: ${setColor.yellowText};
    margin: 0.5rem 0rem;
`;
